export default {
  namespaced: true,
  state: {
    tabIndex: undefined,
    // 我的问题表单数据
    feedback: null,
    // 我的反馈列表
    myList: null,
  },
  mutations: {
    SET_TAB_INDEX(state, tabIndex) {
      state.tabIndex = tabIndex;
    },
    SET_FEEDBACK(state, feedback) {
      state.feedback = feedback;
    },
    SET_MY_LIST(state, myList) {
      state.myList = myList;
    },
  },
};
